export const dropdown3Options = [
  "dropdown3Option2",
  "dropdown3Option3",
  "dropdown3Option4",
  "dropdown3Option5",
  "dropdown3Option6",
];

export const dropdown3OptionsFirst = [
         "dropdown3Option1",
         "dropdown3Option2",
         "dropdown3Option3",
         "dropdown3Option4",
         "dropdown3Option5",
         "dropdown3Option6",
       ];

export const dropdown8Options = [
  "dropdown8Option1",
  "dropdown8Option2",
  "dropdown8Option3",
  "dropdown8Option4",
  "dropdown8Option5",
];

export const dropdown9Options = ["dropdown9Option1", "dropdown9Option2", "dropdown9Option3", "dropdown9Option4"];
export const dropdown10Options = [
  "dropdown10Option1",
  "dropdown10Option2",
  "dropdown10Option3",
  "dropdown10Option4",
  "dropdown10Option5",
  "dropdown10Option6",
];
export const dropdown11Options = ["dropdown11Option1", "dropdown11Option2", "dropdown11Option3", "dropdown11Option4"];
export const dropdown13Options = ["dropdown13Option1", "dropdown13Option2", "dropdown13Option3", "dropdown13Option4"];
export const dropdown14Options = ["dropdown14Option1", "dropdown14Option2", "dropdown14Option3", "dropdown14Option4"];
export const dropdown16Options = ["dropdown16Option1", "dropdown16Option2", "dropdown16Option3", "dropdown16Option4"];
export const dropdown17Options = ["dropdown17Option1", "dropdown17Option2", "dropdown17Option3"];

export const allFields = [
  "field1",
  "field2",
  "field3",
  "field4",
  "field5",
  "field5a",
  "field6",
  "field7a",
  "field7b",
  "field7c",
  "field7",
  "field8",
  "field9",
  "field9a",
  "field10",
  "field11",
  "field11a",
  "field12",
  "field13",
  "field14",
  "field15",
  "field16",
  "field16a",
  "field17",
  "field18",
  "field22",
];

export const fieldsForFirstPart = [
  "field1",
  "field2",
  "field3",
  "field4",
  "field5",
  "field5a",
  "field6",
  "field7a",
  "field7b",
  "field7c",
  "field7",
  "field8",
  "field9",
  "field9a",
  "field10",
  "field11",
  "field11a",
  "field12",
  "field13",
  "field14",
  "field15",
  "field16",
  "field16a",
  "field17",
];

export const dropdown18Options = [
  "dropdown18Option2",
  "dropdown18Option3",
  "dropdown18Option4",
  "dropdown18Option5",
  "dropdown18Option6",
];

export const dropdown18OptionsFirst = [
  "dropdown18Option1",
  "dropdown18Option2",
  "dropdown18Option3",
  "dropdown18Option4",
  "dropdown18Option5",
  "dropdown18Option6",
];

export const dropdown7Options = ["yes", "no"];
export const dropdown7cOptions = ["high", "moderate", "low"];
export const yesAndNoDropdown = ["Yes", "No"];

export const sliderMarks = [
  {
    value: 10,
  },
  {
    value: 20,
  },
  {
    value: 30,
  },
  {
    value: 40,
  },
  {
    value: 50,
  },
];
